export enum IconLuxotticaDimension{
    LARGE="lg",
    MEDIUM="md",
    SMALL="sm",
}